<app-view-title [isPrimaryColor]="true" Title="{{ 'Intellitrailer.Rental.InviteFriends.HeadlineMsg' | translate : 'Invite friends'}}"></app-view-title>
<view-content [centered]="true">
  <app-card>
    @if(!loading) {
    <p class="title invite-friends-title"><strong>{{ appTitle }}</strong></p>
    <p class="invite-friends-p">
      <span [innerHTML]="appDescription"></span>
      @if (this.discountModel.CampaignTerms) {
      <mat-icon (click)="showRule()">info</mat-icon>
      }
    </p>

    <button mat-raised-button (click)="openOffer()">
      {{ 'Intellitrailer.Rental.InviteFriends.btnInvite' | translate : 'Invite' }}
    </button>
    }
    @if(!loading) {
    <div class="summary-area">
      <h3>{{ 'Intellitrailer.Rental.InviteFriends.HowItWorks' | translate : 'How it works' }}</h3>
      <div class="row">
        <div class="col-4">
          <img src="/assets/Images/download.png" />
          <p>{{ 'Intellitrailer.Rental.InviteFriends.ShareUse4FreeViaTheApp' | translate : "Share Use4Free via the app" }}</p>
        </div>
        <div class="col-4">
          <img src="/assets/Images/upload.png" />
          <p>{{ 'Intellitrailer.Rental.InviteFriends.YourFriendDownloadsTheApp' | translate : 'Your friend downloads the app' }}</p>
        </div>
        <div class="col-4">
          <img src="/assets/Images/trailer-image.png" />
          <p>{{ 'Intellitrailer.Rental.InviteFriends.YourFriendRentsYouAreInDraw' | translate : "Your friend rents – you're in the draw" }}</p>
        </div>
      </div>
      <h3>{{ 'Intellitrailer.Rental.InviteFriends.InviteBoard' | translate : 'Invite board' }}</h3>
      <hr class="invite-board-divider" />
      <div class="invite-board">
        @if(discountModel.InvitedFriends?.length > 0) {
        <div class="row">
          <div class="friend-item" *ngFor="let friend of discountModel.InvitedFriends">
            <span>{{ friend.Name }}</span>
            <span>{{ friend.Date | date: 'dd-MMM' }}</span>
          </div>
        </div>
        }
        @else {
        <p>
          {{ 'Intellitrailer.Rental.InviteFriends.messageInviteBoard1' | translate : "You haven’t completed any referrals yet." }}<br />
          {{ 'Intellitrailer.Rental.InviteFriends.messageInviteBoard2' | translate : "Share Use4Free with your friends – every successful booking earns you a spot in the gift card draw!" }}
        </p>
        }
      </div>
    </div>
    }
    @else {
    <div class="spinner-container">
      <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
      <p>{{ 'Intellitrailer.Rental.InviteFriends.Loadingoffer' | translate : 'Loading campaign' }}</p>
    </div>
    }
  </app-card>
</view-content>
<view-actions></view-actions>
